import {useEffect, useState} from "react";
import {useAuth} from "../../shared/auth/AuthContext";
import {getToken} from "../../shared/utils/session";
import {getMyPermissions} from "./UsersService";
import {podeVerUsuarios} from "./usersUtils";
import {sessaoDaEquipeBusifarm} from "./useEquipeBusifarm";

/**
 * Se a sessão vê a gestão de usuários. ADMIN e SUPPORT sempre veem: o identity não aplica escopo a
 * eles. USER só com o recurso de listar usuários num perfil da assinatura do login. Sem resposta,
 * a tela fica escondida, porque a API recusaria a lista do mesmo jeito.
 *
 * Cada renovação da sessão traz um token novo, e a consulta se repete: uma mudança de perfil
 * aparece ali. A resposta anterior vale enquanto isso, para a tela não sumir e voltar no meio do
 * trabalho, e uma falha nessa nova consulta não a esconde.
 */
export const useAcessoAUsuarios = () => {
    const {userLogged} = useAuth() || {};
    const token = getToken(userLogged);
    const equipeBusifarm = sessaoDaEquipeBusifarm(token);
    const [acesso, setAcesso] = useState({carregando: !equipeBusifarm, pode: equipeBusifarm});

    useEffect(() => {
        if (equipeBusifarm) {
            setAcesso({carregando: false, pode: true});
            return undefined;
        }

        let ativo = true;
        getMyPermissions()
            .then((response) => {
                if (ativo) setAcesso({carregando: false, pode: podeVerUsuarios(response?.data?.valor || response?.data)});
            })
            .catch(() => {
                if (ativo) setAcesso((anterior) => ({carregando: false, pode: !anterior.carregando && anterior.pode}));
            });
        return () => {
            ativo = false;
        };
    }, [equipeBusifarm, token]);

    return acesso;
};
